import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { systemRoutes } from '@/router'
import { getSiteInfo } from '@/api/system-config'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login']

/**
 * 将层级路由树展开为扁平叶子路由，path 相对于 Root（/）解析。
 * 叶子路由通过 router.addRoute('Root', route) 注册为 Root Layout 的直接子路由。
 * 容器路由仅生成 redirect 占位。
 *
 * 注意：router.addRoute 注册的子路由 path 会相对于父路由解析，
 * 因此这里输出的是不带前导 / 的相对路径（如 system/user）。
 */
function flattenRoutes(routes, parentPath = '') {
  const result = []
  routes.forEach(route => {
    // 解析相对于当前递归层级父路由的绝对路径（用于跟踪）
    const resolvedPath = route.path === '*'
      ? '*'
      : route.path.startsWith('/')
        ? route.path
        : (parentPath ? parentPath + '/' + route.path : '/' + route.path).replace(/\/+/g, '/')

    // addRoute 中使用的相对路径：去掉前导 / 使其相对于 Root（/）
    const relPath = resolvedPath === '*' ? '*' : resolvedPath.replace(/^\//, '')

    if (route.children && route.children.length > 0) {
      if (route.redirect) {
        result.push({ path: relPath, redirect: route.redirect, hidden: true, meta: route.meta })
      }
      result.push(...flattenRoutes(route.children, resolvedPath))
    } else {
      result.push({ ...route, path: relPath })
    }
  })
  return result
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      const hasRoutes = store.state.permission.addRoutes && store.state.permission.addRoutes.length > 0
      if (hasRoutes) {
        next()
      } else {
        try {
          await store.dispatch('user/getInfo')
          // 获取站点信息（site_name / copyright），登录后带 token 调用确保 AES 加密正常
          getSiteInfo().then(res => {
            if (res.data) {
              store.dispatch('settings/setSiteInfo', res.data)
            }
          }).catch(() => {})
          // 将叶子路由展平后注册到 Root Layout（path 相对于 Root /）
          const flatRoutes = flattenRoutes(systemRoutes)
          flatRoutes.forEach(route => router.addRoute('Root', route))
          store.commit('permission/SET_ROUTES', systemRoutes)
          await Vue.nextTick()
          const targetPath = (to.path === '/' || to.path === '') ? '/dashboard' : to.path
          next({ path: targetPath, replace: true })
        } catch (error) {
          await store.dispatch('user/resetToken')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach((to) => {
  NProgress.done()
  if (to.name && !to.meta?.noCache) {
    store.dispatch('tagsView/addCachedView', to)
  }
})
